import React, { Component } from 'react'
import PageHead from '../../components/pageHead';
import Layout from '../../components/Layout';
import '../../sass/_our-approach.scss';
import '../../sass/_services-details.scss';
import TalkData from '../../components/talk-data';
import { Container, Row, Col } from 'react-bootstrap';
import Cbutton from '../../components/button';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import ScrollAnimation from 'react-wow';
import Header from '../../components/header';

export default class index extends Component {
    render() {
        return (
            <div>
                <Header name="our-approch" />
                <PageHead title="AXLR DATA PVT LTD | Software Solutions"></PageHead>
                <Layout>
                    <section className="devalopement-sec" id="our-sdfd">
                        <Container>
                            <div className="mt-4 mb-4 pt-4 pb-4">
                                <Row>
                                    <Col className="pr-sm-0">
                                        <div className="pl-sm-3">
                                            <ScrollAnimation animation="zoomIn">
                                                <div className="big-heading pt-2">In Process</div>
                                                <div className="big-heading extra-ff">We Trust!</div>
                                            </ScrollAnimation>
                                            <div className="main-content pt-4">
                                            A process that has evolved after
                                            years of practice, it aids us in
                                            nurturing your ideas into
                                            engaging products.
                                            </div>
                                            {/* <div className="mt-sm-4 pt-sm-3 pb-sm-5">
                                                <Cbutton name="Look at Our Work" extra={true} />
                                            </div> */}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </section>
                    <section>
                        <Container>
                            <Row>
                            <Col className="mobile">
                                    <ScrollAnimation animation="zoomIn">
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover.png`} alt="discover" className="mt-5 pt-sm-5 w-100" />
                                    </ScrollAnimation>
                                </Col>
                                <Col md={7}>
                                    <div className="main-heading-home pt-5">Discover</div>
                                    <div className="spectial-content pt-4">
                                        Our journey begins with gathering information about your project.
    Together we understand perspectives of various stakeholders to
    help craft the vision, goals, and scope of the project.
                                    </div>
                                    <div className="spectial-content pt-4">
                                        Brainstorming, whiteboarding, questionnaires and ideation
    sessions help us in identifying needs of the users, discovering the
    strengths and weaknesses of the idea.
                                    </div>
                                    <div className="pt-4">
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Project Requirement Scoping</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Identifying Project/Business Goals</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">User Research</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">UNDERSTANDING USERS</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-sm-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Discovering User Journeys</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-sm-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Reviewing Competition</div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                                <Col className="desktop">
                                    <ScrollAnimation animation="zoomIn">
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover.png`} alt="discover" className="mt-sm-5 pt-sm-5 w-100" />
                                    </ScrollAnimation>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <section className="mt-4 pb-4 mb-4">
                        <Container>
                            <Row>
                                <Col md={5}>
                                    <ScrollAnimation animation="zoomIn">
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/define-sm.png`} alt="define-sm" className="mt-4 p-4 w-100" />
                                    </ScrollAnimation>
                                </Col>
                                <Col>
                                    <div className="main-heading-home pt-5">Define</div>
                                    <div className="spectial-content pt-4">
                                        Once we have identified the business goals of
    the project, we build empathy with the end
    users by understanding them, their persona(s)
    and the challenges they currently face. This
    results in drafting clear problem statements,
    identifying priorities and a project execution
    strategy.
                                    </div>
                                    <div className="pt-4">
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Creating User Personas</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Understanding Customer Journey(s)</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Identifying Problem Statements</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Establishing Feature Priority List</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-sm-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Project Execution Strategy</div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <section className="mt-4 pb-4 mb-4">
                        <Container>
                            <Row>
                            <Col className="mobile">
                                    <ScrollAnimation animation="zoomIn">
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/design-sm-s.png`} alt="design-sm-s" className="pt-4 w-100" />
                                    </ScrollAnimation>
                                </Col>
                                <Col md={7}>
                                    <div className="main-heading-home pt-5">Design</div>
                                    <div className="spectial-content pt-4">
                                        Based on the identified strategies, brand
    guideline is created, comprising of visual
    elements, colour palette, and fonts. High
    fidelity wireframes are created to bring ideas to
    life. Fast prototyping with A/B testing leads to
    brings intuitive designs.
                                    </div>
                                    <div className="pt-4">
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Brand Guideline(s)</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Wireframes</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Interaction Design</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Fast Prototyping</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">A/B Testing</div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                                <Col className="desktop">
                                    <ScrollAnimation animation="zoomIn">
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/design-sm-s.png`} alt="design-sm-s" className="pt-4 w-100" />
                                    </ScrollAnimation>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <section className="mt-4 pb-4 mb-4">
                        <Container>
                            <Row>
                                <Col md={5}>
                                    <ScrollAnimation animation="zoomIn">
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/development-sdd.png`} alt="development-sdd" className="pt-5 w-100" />
                                    </ScrollAnimation>
                                </Col>
                                <Col>
                                    <div className="main-heading-home pt-5">Development</div>
                                    <div className="spectial-content pt-4">
                                        Here, the intuitive designs translate into
    intuitive user journeys through a front-end
    application and a robust back-end. Following
    industry standard best practices, development
    is followed by rigorous testing to ensure the
    applications are functional and usable.
                                    </div>
                                    <div className="pt-4">
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">iOS/Android/Hybrid App Framework</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Front-end Development</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Back-end Development</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">API Integration</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Functional and User Acceptance Testing</div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <section className="mt-4 pb-4 mb-4">
                        <Container>
                            <Row>
                            <Col className="mobile">
                                    <ScrollAnimation animation="zoomIn">
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/deliver-sss.png`} alt="deliver-sss" className="pt-4 w-100" />
                                    </ScrollAnimation>
                                </Col>
                                <Col md={7}>
                                    <div className="main-heading-home pt-5">Deliver</div>
                                    <div className="spectial-content pt-4">
                                        Sprints in the development phase are
    concluded with regular deliverables to ensure
    the product is well tested, expectations met
    with and feedback is incorporated from
    time-to-time. Once a product has cleared all
    checks and validations, including of security
    and maintenance frameworks, it is deployed
    onto your systems
                                    </div>
                                    <div className="pt-4">
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Functional and User Acceptance Testing</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Maintenance</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Security</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Backups</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} xs={1}>
                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                </ScrollAnimation>
                                            </Col>
                                            <Col>
                                                <div className="spectial-content font-sps E7373ERmb">Server Hosting</div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                                <Col className="desktop">
                                    <ScrollAnimation animation="zoomIn">
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/deliver-sss.png`} alt="deliver-sss" className="pt-4 w-100" />
                                    </ScrollAnimation>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <TalkData spectial={true} title={<span>Have an idea <br />you want to execute? <br />Talk to us!</span>} 
                    subtitle=""/>
                </Layout>
                <style>
                    {`
                    body{
                        overflow-x: hidden
                    }
                    .big-heading{
                        font-size: 115px;
                    }
                    .extra-ff{
                        font-size:160px;
                    }
                    @media only screen and (max-width: 768px){
                        #our-sdfd .big-heading {
                            font-size: 55px !important;
                            line-height: 60px !important;
                        }                        
                    }
                    `}
                </style>
            </div>
        )
    }
}
